<div class="container-fluid m-0 p-0" *ngIf="!showLoader">

    <form [formGroup]="createUser" (change)="createUserChange()" (submit)="createUserSubmit()">



        <div class="row bg-white page-head p-3 d-flex flex-wrap justify-content-between">
            <div class="col-md-6 d-flex align-self-center justify-content-center justify-content-lg-start">
                <h6 class="font-bold m-0">{{"CREATE_USER" | translate | titlecase }}</h6>
            </div>
            <div class="col-md-6 d-flex flex-wrap justify-content-center justify-content-lg-end">
                <button type="reset" class="btn btn-outline-secondary m-2 rounded-0" routerLink="/users"
                    *ngIf="!creating">
                    {{"CANCEL" | translate | titlecase }}</button>
                <button type="submit" class="btn btn-primary m-2 rounded-0" *ngIf="!creating"><i
                        class="fas fa-user-plus"></i>
                    {{"SAVE" | translate | titlecase }}</button>
                <app-loader [show]="creating"></app-loader>
            </div>


        </div>

        <div class="row mt-4">

            <div class="col-12">

                <div class="row bg-white border m-0 py-3 ">
                    <!-- <div class="col-md-10 mx-md-auto pt-md-5 px-md-5">
                        <img src="assets/images/avatar.png" class="img-fluid">
                    </div> -->

                    <div class="col-md-10 mx-md-auto py-3">
                        <div class="row">
                            <!-- <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">User Status</label>
                                <select class="form-control custom-select" readonly disabled>
                                    <option value="">Select</option>
                                    <option value="Activated" selected>Activated</option>
                                </select>
                            </div> -->
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"USER_NAME" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="username">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createUser.controls.username.touched && createUser.controls.username.invalid && createUser.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"EMAIL" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="email">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createUser.controls.email.touched && createUser.controls.email.invalid && createUser.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"DISPLAY_NAME" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="displayName">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createUser.controls.displayName.touched && createUser.controls.displayName.invalid && createUser.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"MOBILE" | translate | titlecase }}</label>
                                <input type="input" class="form-control" formControlName="mobile">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createUser.controls.mobile.touched && createUser.controls.mobile.invalid && createUser.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"TYPE" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="type">
                                    <option value="">{{"SELECT" | translate | titlecase }}</option>
                                    <option value="USER">{{"USER" | translate | titlecase }}</option>
                                    <option value="CANDIDATE">{{"CANDIDATE" | translate | titlecase }}</option>
                                    <option value="STUDENT">{{"STUDENT" | translate | titlecase }}</option>
                                    <option value="TEACHER">{{"TEACHER" | translate | titlecase }}</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createUser.controls.type.touched && createUser.controls.type.invalid && createUser.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"ACTIVE" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="active">
                                    <option value="">{{"SELECT" | translate | titlecase }}</option>
                                    <option value="YES">{{"YES" | translate | titlecase }}</option>
                                    <option value="NO">{{"NO" | translate | titlecase }}</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createUser.controls.active.touched && createUser.controls.active.invalid && createUser.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <!-- <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"ORGANIZATION" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="organization">
                                    <option value="">{{"SELECT" | translate | titlecase }}</option>
                                    <option *ngFor="let res of orgs" [ngValue]="res.id">{{
                                        (globals.lang == 'ar')? res.orgNameAr : res.orgNameEn
                                        }}</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createUser.controls.organization.touched && createUser.controls.organization.invalid && createUser.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div> -->
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"ROLE" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="role">
                                    <option value="" [selected]="true">{{"SELECT" | translate | titlecase }}
                                    </option>
                                    <option [ngValue]="res.id" *ngFor="let  res of roles">{{res.roleName}}</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createUser.controls.role.touched && createUser.controls.role.invalid && createUser.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<app-loader [attr.show]="showLoader"></app-loader>